import { space } from "@/design/tokens";

/** Breathing room kept between a focused search field and the native keyboard. */
export const SEARCH_KEYBOARD_GAP = space.xl + space.lg;
